module.exports = __webpack_public_path__ + "img/Spectra Icon_Down.184d027e.svg";